import { Grid, Paper } from '@mui/material'

import { BookingAddressType } from 'generated/graphql'

import { ReadOnlyBookingAddressType } from '.'
import { AddressProvider } from './AddressProvider'
import { SupplierCollectionAddress } from './SupplierCollectionAddress'
import { SupplierDeliveryAddress } from './SupplierDeliveryAddress'

interface ISupplierBookingAddresses {
  addresses: ReadOnlyBookingAddressType[]
}

export const SupplierBookingAddresses = ({ addresses }: ISupplierBookingAddresses) => {
  return (
    <AddressProvider>
      <Grid item xs={12} lg={6}>
        <Paper sx={{ padding: 2 }} variant='outlined'>
          <SupplierCollectionAddress
            addresses={addresses.filter((a) => a.type === BookingAddressType.Collection)}
          />
        </Paper>
      </Grid>

      <Grid item xs={12} lg={6}>
        <Paper sx={{ padding: 2 }} variant='outlined'>
          <SupplierDeliveryAddress
            addresses={addresses.filter((a) => a.type === BookingAddressType.Delivery)}
          />
        </Paper>
      </Grid>
    </AddressProvider>
  )
}
